module.exports = __webpack_public_path__ + "static/media/ruoppaukset-3.9be54cd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ruoppaukset-3.jpg
// module id = 38
// module chunks = 0